import { createMap, forMember, mapFrom } from "@automapper/core";
import { injectable } from "inversify";
import { UpdateAffiliateBtagModelTypeName } from "./constants.js";
import { UserReferralFormModel } from "./service.js";
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let PlayerReferrerInfoMapping = class {
  createMapping(mapper) {
    createMap(
      mapper,
      UserReferralFormModel,
      UpdateAffiliateBtagModelTypeName,
      forMember(
        (vm) => vm.uid,
        mapFrom((m) => m.referee_uid)
      ),
      forMember(
        (vm) => vm.affiliate,
        mapFrom(
          (m) => ({
            btag: m.referrer_id
          })
        )
      ),
      forMember(
        (vm) => vm.id,
        mapFrom((m) => m.id)
      )
    );
  }
};
PlayerReferrerInfoMapping = __decorateClass([
  injectable()
], PlayerReferrerInfoMapping);
export {
  PlayerReferrerInfoMapping
};
//# sourceMappingURL=mapper.js.map
